import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Flex } from '@chakra-ui/react';
import { When } from '../lib/utils/when';
import { VSpacer } from '../lib/spacers/spacer-vertical';
import { HSpacer } from '../lib/spacers/spacer-horizontal';
import { HDivider } from '../lib/layout/divider-horizontal';
import { colors } from '../lib/theme/colors';
import { TextDescription } from '../lib/text/text-description';
import { ExpandUpIconTransparent } from '../lib/icons/expand-up-transparent';
import { ExpandDownIconTransparent } from '../lib/icons/expand-down-transparent';
import { ButtonLink } from './buttons/button-link';
export function ExpandLink(_ref) {
  var title = _ref.title,
      expandableText = _ref.expandableText;

  var _useState = useState(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var changeVisibility = function changeVisibility() {
    return setIsVisible(!isVisible);
  };

  return /*#__PURE__*/_jsxs(Flex, {
    align: "center",
    justify: "center",
    flexDir: "column",
    mt: "4",
    children: [/*#__PURE__*/_jsxs(Flex, {
      align: "center",
      justify: "center",
      children: [/*#__PURE__*/_jsx(ButtonLink, {
        onClick: changeVisibility,
        color: colors.descriptionForeground,
        children: title
      }), /*#__PURE__*/_jsx(VSpacer, {}), /*#__PURE__*/_jsx(When, {
        value: isVisible,
        children: /*#__PURE__*/_jsx(ExpandUpIconTransparent, {})
      }), /*#__PURE__*/_jsx(When, {
        value: !isVisible,
        children: /*#__PURE__*/_jsx(ExpandDownIconTransparent, {})
      })]
    }), /*#__PURE__*/_jsx(HSpacer, {}), /*#__PURE__*/_jsxs(When, {
      value: isVisible,
      children: [/*#__PURE__*/_jsx(HDivider, {}), /*#__PURE__*/_jsx(HSpacer, {}), /*#__PURE__*/_jsx(TextDescription, {
        children: expandableText
      })]
    })]
  });
}